import { ConfigurationManager } from '../configuration-manager/configuration-manager';
import log from 'loglevel';

/**
 * Generates a url to unsubscribe the user from CrossEngage segmentation and messages.
 * @param channel is the string of a single channel or `all`
 * @param callback is a function that returns the optout url.
 */
export default function(channel: string, callback: (linkUrl: string) => void) {
  if (typeof channel !== 'string' || !callback) {
    log.error(`The provided arguments are invalid. Please provide a channel string and a callback function.`);
    return;
  };
  const config = ConfigurationManager.getConfigState();
  callback(`https://trk-api.crossengage.io/optout/inbound/webhook/${config.apiKey}/${config.globalUserId}?channelType=${channel}`);
}